 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"icon-":"icon-","icon-account_circle":"icon-account_circle","icon-add":"icon-add","icon-add_circle_outline":"icon-add_circle_outline","icon-admin_panel_settings":"icon-admin_panel_settings","icon-alert":"icon-alert","icon-apps":"icon-apps","icon-arrow_back":"icon-arrow_back","icon-assignment":"icon-assignment","icon-assignment_turned_in":"icon-assignment_turned_in","icon-attach_file":"icon-attach_file","icon-calendar":"icon-calendar","icon-call":"icon-call","icon-call_end":"icon-call_end","icon-chart":"icon-chart","icon-chart-bubble":"icon-chart-bubble","icon-check":"icon-check","icon-check_circle_outline":"icon-check_circle_outline","icon-chevron_left":"icon-chevron_left","icon-chevron_left_double":"icon-chevron_left_double","icon-chevron_right":"icon-chevron_right","icon-chevron_right_double":"icon-chevron_right_double","icon-clear":"icon-clear","icon-delete_forever":"icon-delete_forever","icon-description":"icon-description","icon-diabetes":"icon-diabetes","icon-dni":"icon-dni","icon-edit":"icon-edit","icon-email":"icon-email","icon-event_available":"icon-event_available","icon-expand_more":"icon-expand_more","icon-favorite":"icon-favorite","icon-filter":"icon-filter","icon-fitness_center":"icon-fitness_center","icon-forum":"icon-forum","icon-gauge":"icon-gauge","icon-healing":"icon-healing","icon-highlight_off":"icon-highlight_off","icon-history":"icon-history","icon-human-male-height":"icon-human-male-height","icon-id_card":"icon-id_card","icon-image":"icon-image","icon-info":"icon-info","icon-insert_chart_outlined":"icon-insert_chart_outlined","icon-institution":"icon-institution","icon-label":"icon-label","icon-link":"icon-link","icon-list":"icon-list","icon-local_hospital":"icon-local_hospital","icon-local_pharmacy":"icon-local_pharmacy","icon-location_on":"icon-location_on","icon-lock":"icon-lock","icon-lock_open":"icon-lock_open","icon-loyalty":"icon-loyalty","icon-lungs":"icon-lungs","icon-man":"icon-man","icon-medical-specialty":"icon-medical-specialty","icon-medical_services":"icon-medical_services","icon-message":"icon-message","icon-mic":"icon-mic","icon-mic_off":"icon-mic_off","icon-more_horiz":"icon-more_horiz","icon-note_add":"icon-note_add","icon-notifications_active":"icon-notifications_active","icon-notifications_off":"icon-notifications_off","icon-pending_actions":"icon-pending_actions","icon-people":"icon-people","icon-perm_contact_calendar":"icon-perm_contact_calendar","icon-person":"icon-person","icon-phone_iphone":"icon-phone_iphone","icon-phonelink":"icon-phonelink","icon-phonelink_erase":"icon-phonelink_erase","icon-phonelink_ring":"icon-phonelink_ring","icon-playlist_add":"icon-playlist_add","icon-pulse":"icon-pulse","icon-refresh":"icon-refresh","icon-reorder":"icon-reorder","icon-reply":"icon-reply","icon-search":"icon-search","icon-sentiment_satisfied_alt":"icon-sentiment_satisfied_alt","icon-settings":"icon-settings","icon-shoe-print":"icon-shoe-print","icon-smartphone":"icon-smartphone","icon-thermometer":"icon-thermometer","icon-today":"icon-today","icon-videocam":"icon-videocam","icon-videocam_off":"icon-videocam_off","icon-videogame":"icon-videogame","icon-visibility":"icon-visibility","icon-weight":"icon-weight","icon-woman":"icon-woman","patient~treatment":"patient~treatment","patient":"patient","treatment":"treatment","user":"user"}[chunkId]||chunkId) + "." + {"icon-":"e0ea1f3a","icon-account_circle":"5cb2a053","icon-add":"3f5e546b","icon-add_circle_outline":"956c7fb7","icon-admin_panel_settings":"1c702c5e","icon-alert":"d4135ff0","icon-apps":"d8c813cd","icon-arrow_back":"f2518973","icon-assignment":"e78d9166","icon-assignment_turned_in":"6652d89d","icon-attach_file":"b3bb20a3","icon-calendar":"f8bba286","icon-call":"e211fc52","icon-call_end":"5734b72b","icon-chart":"4c166dcb","icon-chart-bubble":"1764d99d","icon-check":"d9027902","icon-check_circle_outline":"cb6d862d","icon-chevron_left":"ab410041","icon-chevron_left_double":"141183d8","icon-chevron_right":"8be88095","icon-chevron_right_double":"65f09c5b","icon-clear":"b5e68b81","icon-delete_forever":"83675bf8","icon-description":"3573a656","icon-diabetes":"f22bd375","icon-dni":"c27a47aa","icon-edit":"f2b280db","icon-email":"b735ae17","icon-event_available":"d8500913","icon-expand_more":"f27614d4","icon-favorite":"15848526","icon-filter":"17c359ea","icon-fitness_center":"1d893c53","icon-forum":"733c50b8","icon-gauge":"174d419e","icon-healing":"97fa2778","icon-highlight_off":"808808ca","icon-history":"ef1b244e","icon-human-male-height":"9d615471","icon-id_card":"4d6016bc","icon-image":"1c41e150","icon-info":"e2c7aaf5","icon-insert_chart_outlined":"f27cf9ce","icon-institution":"da3b6857","icon-label":"d5cfa730","icon-link":"22ae1158","icon-list":"59772194","icon-local_hospital":"e6c9a1ed","icon-local_pharmacy":"b0de2931","icon-location_on":"c12cc598","icon-lock":"9bc0343e","icon-lock_open":"5a6cecc0","icon-loyalty":"98ca8c0e","icon-lungs":"7d234bcc","icon-man":"c3b12286","icon-medical-specialty":"ef32ae47","icon-medical_services":"8fbcb064","icon-message":"4b68a68b","icon-mic":"e60ee663","icon-mic_off":"bcebf1c4","icon-more_horiz":"ad012fb6","icon-note_add":"a0def6bd","icon-notifications_active":"c4ac17e3","icon-notifications_off":"0d68c930","icon-pending_actions":"93e48bd7","icon-people":"4e4b46f8","icon-perm_contact_calendar":"141fb789","icon-person":"c5bdb397","icon-phone_iphone":"2f670cf5","icon-phonelink":"b8616b9c","icon-phonelink_erase":"b6c1180e","icon-phonelink_ring":"a400166e","icon-playlist_add":"97a68c30","icon-pulse":"200c982e","icon-refresh":"99de3f19","icon-reorder":"0d35b270","icon-reply":"ccf2264a","icon-search":"2ea3c5a0","icon-sentiment_satisfied_alt":"c36c4376","icon-settings":"e61fe946","icon-shoe-print":"194a3318","icon-smartphone":"c3e1505a","icon-thermometer":"c0c91168","icon-today":"7f28d01a","icon-videocam":"330bd724","icon-videocam_off":"24ed03b4","icon-videogame":"4a38c76a","icon-visibility":"4dc816c9","icon-weight":"9b69dd0a","icon-woman":"fa2d1c98","patient~treatment":"87d3d036","patient":"e9fed7bf","treatment":"4f22449c","user":"ce5941cc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"patient~treatment":1,"patient":1,"treatment":1,"user":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"icon-":"icon-","icon-account_circle":"icon-account_circle","icon-add":"icon-add","icon-add_circle_outline":"icon-add_circle_outline","icon-admin_panel_settings":"icon-admin_panel_settings","icon-alert":"icon-alert","icon-apps":"icon-apps","icon-arrow_back":"icon-arrow_back","icon-assignment":"icon-assignment","icon-assignment_turned_in":"icon-assignment_turned_in","icon-attach_file":"icon-attach_file","icon-calendar":"icon-calendar","icon-call":"icon-call","icon-call_end":"icon-call_end","icon-chart":"icon-chart","icon-chart-bubble":"icon-chart-bubble","icon-check":"icon-check","icon-check_circle_outline":"icon-check_circle_outline","icon-chevron_left":"icon-chevron_left","icon-chevron_left_double":"icon-chevron_left_double","icon-chevron_right":"icon-chevron_right","icon-chevron_right_double":"icon-chevron_right_double","icon-clear":"icon-clear","icon-delete_forever":"icon-delete_forever","icon-description":"icon-description","icon-diabetes":"icon-diabetes","icon-dni":"icon-dni","icon-edit":"icon-edit","icon-email":"icon-email","icon-event_available":"icon-event_available","icon-expand_more":"icon-expand_more","icon-favorite":"icon-favorite","icon-filter":"icon-filter","icon-fitness_center":"icon-fitness_center","icon-forum":"icon-forum","icon-gauge":"icon-gauge","icon-healing":"icon-healing","icon-highlight_off":"icon-highlight_off","icon-history":"icon-history","icon-human-male-height":"icon-human-male-height","icon-id_card":"icon-id_card","icon-image":"icon-image","icon-info":"icon-info","icon-insert_chart_outlined":"icon-insert_chart_outlined","icon-institution":"icon-institution","icon-label":"icon-label","icon-link":"icon-link","icon-list":"icon-list","icon-local_hospital":"icon-local_hospital","icon-local_pharmacy":"icon-local_pharmacy","icon-location_on":"icon-location_on","icon-lock":"icon-lock","icon-lock_open":"icon-lock_open","icon-loyalty":"icon-loyalty","icon-lungs":"icon-lungs","icon-man":"icon-man","icon-medical-specialty":"icon-medical-specialty","icon-medical_services":"icon-medical_services","icon-message":"icon-message","icon-mic":"icon-mic","icon-mic_off":"icon-mic_off","icon-more_horiz":"icon-more_horiz","icon-note_add":"icon-note_add","icon-notifications_active":"icon-notifications_active","icon-notifications_off":"icon-notifications_off","icon-pending_actions":"icon-pending_actions","icon-people":"icon-people","icon-perm_contact_calendar":"icon-perm_contact_calendar","icon-person":"icon-person","icon-phone_iphone":"icon-phone_iphone","icon-phonelink":"icon-phonelink","icon-phonelink_erase":"icon-phonelink_erase","icon-phonelink_ring":"icon-phonelink_ring","icon-playlist_add":"icon-playlist_add","icon-pulse":"icon-pulse","icon-refresh":"icon-refresh","icon-reorder":"icon-reorder","icon-reply":"icon-reply","icon-search":"icon-search","icon-sentiment_satisfied_alt":"icon-sentiment_satisfied_alt","icon-settings":"icon-settings","icon-shoe-print":"icon-shoe-print","icon-smartphone":"icon-smartphone","icon-thermometer":"icon-thermometer","icon-today":"icon-today","icon-videocam":"icon-videocam","icon-videocam_off":"icon-videocam_off","icon-videogame":"icon-videogame","icon-visibility":"icon-visibility","icon-weight":"icon-weight","icon-woman":"icon-woman","patient~treatment":"patient~treatment","patient":"patient","treatment":"treatment","user":"user"}[chunkId]||chunkId) + "." + {"icon-":"31d6cfe0","icon-account_circle":"31d6cfe0","icon-add":"31d6cfe0","icon-add_circle_outline":"31d6cfe0","icon-admin_panel_settings":"31d6cfe0","icon-alert":"31d6cfe0","icon-apps":"31d6cfe0","icon-arrow_back":"31d6cfe0","icon-assignment":"31d6cfe0","icon-assignment_turned_in":"31d6cfe0","icon-attach_file":"31d6cfe0","icon-calendar":"31d6cfe0","icon-call":"31d6cfe0","icon-call_end":"31d6cfe0","icon-chart":"31d6cfe0","icon-chart-bubble":"31d6cfe0","icon-check":"31d6cfe0","icon-check_circle_outline":"31d6cfe0","icon-chevron_left":"31d6cfe0","icon-chevron_left_double":"31d6cfe0","icon-chevron_right":"31d6cfe0","icon-chevron_right_double":"31d6cfe0","icon-clear":"31d6cfe0","icon-delete_forever":"31d6cfe0","icon-description":"31d6cfe0","icon-diabetes":"31d6cfe0","icon-dni":"31d6cfe0","icon-edit":"31d6cfe0","icon-email":"31d6cfe0","icon-event_available":"31d6cfe0","icon-expand_more":"31d6cfe0","icon-favorite":"31d6cfe0","icon-filter":"31d6cfe0","icon-fitness_center":"31d6cfe0","icon-forum":"31d6cfe0","icon-gauge":"31d6cfe0","icon-healing":"31d6cfe0","icon-highlight_off":"31d6cfe0","icon-history":"31d6cfe0","icon-human-male-height":"31d6cfe0","icon-id_card":"31d6cfe0","icon-image":"31d6cfe0","icon-info":"31d6cfe0","icon-insert_chart_outlined":"31d6cfe0","icon-institution":"31d6cfe0","icon-label":"31d6cfe0","icon-link":"31d6cfe0","icon-list":"31d6cfe0","icon-local_hospital":"31d6cfe0","icon-local_pharmacy":"31d6cfe0","icon-location_on":"31d6cfe0","icon-lock":"31d6cfe0","icon-lock_open":"31d6cfe0","icon-loyalty":"31d6cfe0","icon-lungs":"31d6cfe0","icon-man":"31d6cfe0","icon-medical-specialty":"31d6cfe0","icon-medical_services":"31d6cfe0","icon-message":"31d6cfe0","icon-mic":"31d6cfe0","icon-mic_off":"31d6cfe0","icon-more_horiz":"31d6cfe0","icon-note_add":"31d6cfe0","icon-notifications_active":"31d6cfe0","icon-notifications_off":"31d6cfe0","icon-pending_actions":"31d6cfe0","icon-people":"31d6cfe0","icon-perm_contact_calendar":"31d6cfe0","icon-person":"31d6cfe0","icon-phone_iphone":"31d6cfe0","icon-phonelink":"31d6cfe0","icon-phonelink_erase":"31d6cfe0","icon-phonelink_ring":"31d6cfe0","icon-playlist_add":"31d6cfe0","icon-pulse":"31d6cfe0","icon-refresh":"31d6cfe0","icon-reorder":"31d6cfe0","icon-reply":"31d6cfe0","icon-search":"31d6cfe0","icon-sentiment_satisfied_alt":"31d6cfe0","icon-settings":"31d6cfe0","icon-shoe-print":"31d6cfe0","icon-smartphone":"31d6cfe0","icon-thermometer":"31d6cfe0","icon-today":"31d6cfe0","icon-videocam":"31d6cfe0","icon-videocam_off":"31d6cfe0","icon-videogame":"31d6cfe0","icon-visibility":"31d6cfe0","icon-weight":"31d6cfe0","icon-woman":"31d6cfe0","patient~treatment":"da3fab8e","patient":"4b6da0c2","treatment":"13471dc9","user":"b8bb8157"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
